export var DOT_SYMBOL = '&#8226;';